import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/sitiClienti';

const routes = helper.generateRoutes('sitiClienti', selectors);

routes.list.list.breadcrumb = 'Configurazione Cookie';

const list = _.values(routes.list).map(route => ({
    ...route,
    // hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'sitiClienti' */ `modules/sitiClienti/${
                route.componentPath
                }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('sitiClienti', routes.patterns, {
    it: 'SitiClienti'
});
routeRegister.addLinks('sitiClienti', links);

export default list;
